//Corresponding API model located in API project at
//API\IMS.Models\Services\Applications\Applications\Apps.cs
//Only edit if the Apps model or one of its dependencies were updated in the API causing error

export default class Apps {
	constructor(response) {
		this.trackingNumber = response ? response.TrackingNumber : null;
		this.userId = response ? response.UserId : null;
		this.applications = response
			? this.parseApplications(response.Applications)
			: [];
		this.dependencyMap = response ? response.dependencyMap : null;
		this.rulesReverseLookup = response ? response.rulesReverseLookup : null;
	}

	parseApplications(applicationsArr) {
		if (applicationsArr) {
			let appModels = applicationsArr.map(app => {
				return new AppModel(app);
			});

			return appModels;
		} else {
			return [];
		}
	}
}

export class AppModel {
	constructor(appModel) {
		this.id = appModel ? appModel.id : null;
		this.isActive = appModel ? appModel.IsActive : null;
		this.name = appModel ? appModel.Name : null;
		this.componentType = appModel ? appModel.ComponentType : null;
		this.action = appModel ? appModel.Action : null;
		this.contractModel = appModel ? appModel.ContractModel : null;
		this.userId = appModel ? appModel.UserID : null;
		this.usernameType = appModel ? appModel.usernameType : null;
		this.roleLink = appModel ? appModel.RoleLink : null;
		this.email = appModel ? appModel.Email : null;
		this.submitted = appModel ? appModel.Submitted : null;
		this.rules = appModel ? appModel.rules : null;
		this.appInfo =
			appModel && appModel.AppInfo
				? new AppInfo(appModel.AppInfo)
				: new AppInfo({});
		this.appAux =
			appModel && appModel.AppAux ? new AppAux(appModel.AppAux) : null;
	}
}

export class AppAux {
	constructor(appAux) {
		this.id = appAux ? appAux.ID : null;
		this.appID = appAux ? appAux.AppID : null;
		this.pwdSynch_Flag = appAux ? appAux.PwdSynch_Flag : null;
		this.unlock_Flag = appAux ? appAux.Unlock_Flag : null;
		this.changeUsernameFlag = appAux ? appAux.ChangeUsernameFlag : null;
		this.challengeResponse_Flag = appAux
			? appAux.ChallengeResponse_Flag
			: null;
		this.requestClassName = appAux ? appAux.RequestClassName : null;
		this.requestAssemblyName = appAux ? appAux.RequestAssemblyName : null;
		this.submissionAlertRecipients = appAux
			? appAux.SubmissionAlertRecipients
			: null;
		this.omitPwdFromRequestorEmail = appAux
			? appAux.OmitPwdFromRequestorEmail
			: null;
		this.terminatorClassName = appAux ? appAux.TerminatorClassName : null;
		this.terminatorAssemblyName = appAux
			? appAux.TerminatorAssemblyName
			: null;
		this.rapFlag = appAux ? appAux.RAPFlag : null;
		this.authenticationAppID = appAux ? appAux.AuthenticationAppID : null;
		this.lowMark = appAux ? appAux.LowMark : null;
		this.highMark = appAux ? appAux.HighMark : null;
		this.reactAppType = appAux ? appAux.ReactAppType : 'Simple';
		this.roleDescriptionLink = appAux ? appAux.RoleDescriptionLink : null;
		this.userNameTypeID = appAux ? appAux.UserNameTypeID : null;
		this.wQ1MoveAlertRecipients = appAux
			? appAux.WQ1MoveAlertRecipients
			: null;
		this.wQ2MoveAlertRecipients = appAux
			? appAux.WQ2MoveAlertRecipients
			: null;
		this.wQ3MoveAlertRecipients = appAux
			? appAux.WQ3MoveAlertRecipients
			: null;
		this.isSafeToEdit = appAux ? appAux.IsSafeToEdit : null;
	}
}

export class AppInfo {
	constructor(infoModel) {
		this.id = infoModel && infoModel.ID ? infoModel.ID : null;
		this.applicationName = infoModel ? infoModel.ApplicationName : null;
		this.applicationType = infoModel ? infoModel.ApplicationType : null;
		this.alias = infoModel ? infoModel.Alias : null;
		this.shortDescription = infoModel ? infoModel.ShortDescription : null;
		this.description = infoModel ? infoModel.Description : null;
		this.training = infoModel ? infoModel.Training : null;
		this.typicalUsers = infoModel ? infoModel.TypicalUsers : null;
		this.help = infoModel ? infoModel.Help : null;
		this.quickStart = infoModel ? infoModel.QuickStart : null;
		this.additionalInformation = infoModel
			? infoModel.AdditionalInformation
			: null;
		this.managingDepartment = infoModel
			? infoModel.ManagingDepartment
			: null;
		this.dataClassification = infoModel
			? infoModel.DataClassification
			: null;
		this.imsApplicationMapping = infoModel
			? infoModel.IMSApplicationMapping
			: null;
		this.howToGet = infoModel ? infoModel.HowToGet : null;
		this.adGroup = infoModel ? infoModel.ADGroup : null;
		this.accessInstructions = infoModel
			? infoModel.AccessInstructions
			: null;
		this.locations = infoModel
			? new App_Locations(infoModel.Locations)
			: new App_Locations();
		this.securityContact = infoModel
			? new App_Contacts(infoModel.SecurityContact, 'SECURITY')
			: new App_Contacts(null, 'SECURITY');
		this.privacyContact = infoModel
			? new App_Contacts(infoModel.PrivacyContact, 'PRIVACY')
			: new App_Contacts(null, 'PRIVACY');
		this.technicalTeam = infoModel
			? new App_Contacts(infoModel.TechnicalTeam, 'TEAM')
			: new App_Contacts(null, 'TEAM');
		this.owners = infoModel
			? new App_Contacts(infoModel.Owners, 'Owner')
			: new App_Contacts(null, 'Owner');
		this.upmc_App_ID = infoModel ? infoModel.UPMC_App_ID : null;
		this.UPMCAppType = infoModel ? infoModel.UPMCAppType : null;
	}
}

export class App_Locations {
	constructor(locations) {
		this.displayFormattedLocations =
			locations && locations.DisplayFormattedLocations
				? locations.DisplayFormattedLocations
				: '';
		this.locationData =
			locations && locations.LocationData ? locations.LocationData : [];
	}
}

export class App_Contacts {
	constructor(contacts, type) {
		this.type = type;
		this.displayFormattedContacts =
			contacts && contacts.DisplayFormattedContacts
				? contacts.DisplayFormattedContacts
				: '';
		this.contactData =
			contacts && contacts.ContactData ? contacts.ContactData : [];
	}
}

//api model: BaseAppADGroup
export class AppADGroup {
	constructor(baseAppADGroup) {
		this.id = baseAppADGroup ? baseAppADGroup.ID : null;
		this.aDGroup_SID = baseAppADGroup ? baseAppADGroup.ADGroup_SID : null;
		this.appID = baseAppADGroup ? baseAppADGroup.AppID : null;
		this.appRoleID = baseAppADGroup ? baseAppADGroup.AppRoleID : null;
		this.sqlStatementID = baseAppADGroup
			? baseAppADGroup.SQLStatementID
			: null;
		this.active = baseAppADGroup ? baseAppADGroup.Active : null;
		this.sqlStatement = baseAppADGroup ? baseAppADGroup.SQLStatement : null;
		this.adGroup = baseAppADGroup?.ADGroup
			? new ADGroup(baseAppADGroup.ADGroup)
			: new ADGroup();
	}
}

export class AppCloudGroup {
	constructor(baseAppCloudGroup){
		this.id = baseAppCloudGroup ? baseAppCloudGroup.ID : null;
		this.appID = baseAppCloudGroup ? baseAppCloudGroup.AppID : null;
		this.groupDisplayName = baseAppCloudGroup
			? baseAppCloudGroup.GroupDisplayName
			: null;
		this.active = baseAppCloudGroup
			? baseAppCloudGroup.Active
			: null;
		this.sqlStatement = baseAppCloudGroup
			? baseAppCloudGroup.SQLStatement
			: null;
		this.emailRequired = baseAppCloudGroup
			? baseAppCloudGroup.EmailRequired
			: null;
	}
}

export class AppEUGroup {
	constructor(baseAppEUGroup) {
		this.id = baseAppEUGroup ? baseAppEUGroup.ID : null;
		this.appID = baseAppEUGroup ? baseAppEUGroup.AppID : null;
		this.groupName = baseAppEUGroup
			? baseAppEUGroup.GroupName
			: null;
		this.active = baseAppEUGroup ? baseAppEUGroup.Active : null;
		this.sqlStatement = baseAppEUGroup
			? baseAppEUGroup.SQLStatement
			: null;
	}
}

export class ADGroup {
	constructor(baseADGroup) {
		this.id = baseADGroup ? baseADGroup.ID : null;
		this.samAccountName = baseADGroup ? baseADGroup.SamAccountName : null;
		this.distinguishedName = baseADGroup
			? baseADGroup.DistinguishedName
			: null;
		this.description = baseADGroup ? baseADGroup.Description : null;
		this.active = baseADGroup ? baseADGroup.Active : null;
		this.cn = baseADGroup ? baseADGroup.CN : null;
		this.objectSID = baseADGroup ? baseADGroup.ObjectSID : null;
		this.objectGUID = baseADGroup ? baseADGroup.ObjectGUID : null;
		this.groupType = baseADGroup ? baseADGroup.GroupType : null;
		this.clinicalAccess = baseADGroup ? baseADGroup.ClinicalAcces : null;
		this.privilegedFlag = baseADGroup ? baseADGroup.PrivilegedFlag : null;
	}
}

export class CloudGroup {
	constructor(baseCloudGroup){
		this.id = baseCloudGroup ? baseCloudGroup.ID : null;
		this.mailNickname = baseCloudGroup ? baseCloudGroup.MailNickName : null;
		this.mailEnabled = baseCloudGroup ? baseCloudGroup.MailEnabled : null;
		this.securityEnabled = baseCloudGroup ? baseCloudGroup.SecurityEnabled : null;
		this.displayName = baseCloudGroup ? baseCloudGroup.DisplayName : null;
		this.description = baseCloudGroup ? baseCloudGroup.Description : null;
		this.groupType = baseCloudGroup ? baseCloudGroup.GroupType : null;
		this.onPremSAMAccountName = baseCloudGroup ? baseCloudGroup.OnPremisesSamAccountName : null;
		this.azureID = baseCloudGroup ? baseCloudGroup.AzureID : null;
		this.isAssignableToRole = baseCloudGroup ? baseCloudGroup.IsAssignableToRole : null;
	}
}

export class EUGroup {
	constructor(baseEUGroup) {
		this.id = baseEUGroup ? baseEUGroup.ID : null;
		this.samAccountName = baseEUGroup ? baseEUGroup.SAMAccountName : null;
		this.distinguishedName = baseEUGroup ? baseEUGroup.DistinguishedName : null;
		this.description = baseEUGroup ? baseEUGroup.Description : null;
		this.active = baseEUGroup ? baseEUGroup.Active : null;
		this.cn = baseEUGroup ? baseEUGroup.CN : null;
		this.objectSID = baseEUGroup ? baseEUGroup.ObjectSID : null;
		this.objectGUID = baseEUGroup ? baseEUGroup.ObjectGUID : null;
		this.groupTypeID = baseEUGroup ? baseEUGroup.GroupTypeID : null;
		this.clinicalAccess = baseEUGroup ? baseEUGroup.ClinicalAccess : null;
		this.privilegedFlag = baseEUGroup ? baseEUGroup.PrivilegedFlag : null;
	}
}

export class AppDistributionList {
	constructor(appDistributionList) {
		this.appID = appDistributionList ? appDistributionList.AppID : null;
		this.distributionListName = appDistributionList
			? appDistributionList.distributionListName
			: null;
		this.sqlStatement = appDistributionList
			? appDistributionList.SQLStatement
			: null;
		this.id = appDistributionList ? appDistributionList.ID : null;
	}
}
